// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"80a50e8b","408":"dabb4982","476":"09f243b3","580":"48e0e0ef","617":"753a4d90","682":"1240ae82","727":"79eafd62","876":"dfab5721","925":"428aa1a9","981":"fd3bbb33"}[chunkId] + ".chunk.js";
};